import * as React from "react";

// Inspired from https://reactjs.org/docs/hooks-faq.html#how-to-read-an-often-changing-value-from-usecallback
export function useMemoizedCallback<T extends (...args: any[]) => any>(fn: T): T {
  const ref = React.useRef<T>(fn);
  ref.current = fn;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return React.useCallback<T>(((...args) => ref.current(...args)) as T, []);
}
